//关于rewardType的过滤器 弹窗详情使用
define('filters/appmng/reward-type.filter',['app'], function (app) {
    app.filter('rewardTypeFilter', function () {
        return function (gBalance) {
            if (!gBalance) {
                return '';
            }
            if (gBalance.accountType == 3 && gBalance.giftType == 1) {
                return '纯赠送';
            }
            if (gBalance.accountType == 3 && gBalance.giftType == 2) {
                return '充值赠送';
            }
            if (gBalance.accountType == 4) {
                return '消耗返利';
            }
            return '--';
        };
    });
});

